export default __webpack_public_path__ + "static/media/heart.434029b2.svg";